import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "../styles/PageTransition.css";

export default function PageTransition({ children }) {
  const location          = useLocation()
  const [visible, setVisible] = useState(false)
  const prevPath          = useRef(location.pathname)
  const timerRef          = useRef(null)

  // Fade in on first mount — use a short timeout so the browser
  // has painted the initial (hidden) frame before we trigger the transition.
  useEffect(() => {
    const id = setTimeout(() => setVisible(true), 20)
    return () => clearTimeout(id)
  }, [])

  useEffect(() => {
    if (location.pathname === prevPath.current) return
    setVisible(false)
    timerRef.current = setTimeout(() => {
      prevPath.current = location.pathname
      setVisible(true)
    }, 220)
    return () => clearTimeout(timerRef.current)
  }, [location.pathname])

  return (
    <div className={`page-transition${visible ? " visible" : ""}`}>
      {children}
    </div>
  )
}